let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '广告位ID',
        props: 'adNo',
        minWidth: 220,
    },
    {
        label: '广告位置名称',
        props: 'adName',
        minWidth: 200,
    },
    {
        label: '广告位图片数',
        props: 'picSize',
        minWidth: 200,
    },
    {
        label: '轮播时间(S)',
        props: 'adTime',
        minWidth: 180,
    },
    {
        label: '更新人',
        props: 'lastModifiedByName',
        minWidth: 150,
    },
    {
        label: '更新时间',
        props: 'lastModifiedWhen',
        minWidth: 180,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理'
    },
    {
        type: 'title',
        name: '广告位配置'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}


// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};
pageConfig.logBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '广告位配置',
        router: 'advertisingSpaceConfiguration'
    },
    {
        type: 'title',
        name: '更新记录'
    }
];
pageConfig.historyBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '优惠券管理',
    },
    {
        type: 'router',
        name: '广告位配置',
        router: 'advertisingSpaceConfiguration'
    },
    {
        type: 'title',
        name: '历史查看'
    }
];
// 路由
pageConfig.listRouter = 'advertisingSpaceConfiguration';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '广告位管理',
    },
    {
        type: 'router',
        name: '广告位配置',
        router: 'advertisingSpaceConfiguration'
    },
    {
        type: 'title',
        name: '广告位编辑'
    }
];

function fileMustUpload(rule, value, callback) {
    if (this.formData.img == null) {
      // 未上传文件
      callback("请上传图标");
    }
    callback();//
  };
pageConfig.formRules = {
    adName: [{ required: true, message: '请输入广告位置名称', trigger: 'blur' }],
    picSize: [{ required: true, message: '请选择广告轮播时间', trigger: 'change' }],
};
pageConfig.listFormRules = {
    pictureName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
    startTime: [{ required: true, message: '请选择启用时间', trigger: 'change' }],
    // endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
    filterType: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
    pictureUrl: [{ required: true, message: '请输入跳转地址', trigger: 'blur' }],
    imageBs: [ 
        {  required: true,
            message: '请上传图片',}
    ],
};



export default pageConfig;
